<template>
  <div style="display: contents">
    <tr>
      <td :style="{ 'padding-left': (level * 20) + 'px' }">
        <template v-if="hasChildren">
          <span @click="expanded = !expanded" class="cursor-pointer mr-2">
            <fa :icon="expanded ? 'minus' : 'plus'" />
          </span>
        </template>
        {{ product.name || product.product_master_id }}
        <fa 
          icon="pencil-alt" 
          @click="openProductDetail" 
          class="cursor-pointer ml-2 text-primary"
          style="font-size: 0.9em;"
        />
      </td>
      <td v-for="salesLine in salesLines" :key="salesLine.id" class="text-center">
        <product-matrix-cell
          :product-master-id="product.id"
          :sales-line-id="salesLine.id"
          :sales-line-data="getSalesLineData(salesLine.id)"
          @update="handleCellUpdate"
        />
      </td>
    </tr>
    <template v-if="expanded && hasChildren">
      <product-matrix-row
        v-for="child in product.children"
        :key="child.id"
        :product="child"
        :sales-lines="salesLines"
        :level="level + 1"
        @update="handleUpdate"
      />
    </template>
  </div>
</template>

<script>
import ProductMatrixCell from './ProductMatrixCell'

export default {
  name: 'ProductMatrixRow',
  components: {
    ProductMatrixCell
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    salesLines: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    hasChildren() {
      return this.product.children && this.product.children.length > 0
    }
  },
  methods: {
    getSalesLineData(salesLineId) {
      return this.product.sales_lines_data && this.product.sales_lines_data[salesLineId]
        ? this.product.sales_lines_data[salesLineId]
        : null
    },
    handleCellUpdate(data) {
      this.$emit('update', this.product.id, data.sales_line_id, data)
    },
    handleUpdate(productMasterId, salesLineId, data) {
      this.$emit('update', productMasterId, salesLineId, data)
    },
    openProductDetail() {
      const route = this.$router.resolve({ path: `/sandoz/product_masters/${this.product.id}` })
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
